export const itemTemplate = (item: string): string => (
  `<div class='autocomplete-suggestion' data-val='${item}'>
    ${ item }
  </div>`
)
